import { default as _91_46_46_46route_933WvvN7atK3Meta } from "/builds/webcontact/bad-peterstal-griesbach/pages/[...route].vue?macro=true";
import { default as buerger_45indexpEMkpJMClSMeta } from "/builds/webcontact/bad-peterstal-griesbach/pages/buerger-index.vue?macro=true";
import { default as exampleBpFCfJM7nuMeta } from "/builds/webcontact/bad-peterstal-griesbach/pages/example.vue?macro=true";
import { default as indexwXxLu5D1w0Meta } from "/builds/webcontact/bad-peterstal-griesbach/pages/index.vue?macro=true";
export default [
  {
    name: "route",
    path: "/:route(.*)*",
    meta: _91_46_46_46route_933WvvN7atK3Meta || {},
    component: () => import("/builds/webcontact/bad-peterstal-griesbach/pages/[...route].vue")
  },
  {
    name: "buerger-index",
    path: "/buerger-index",
    component: () => import("/builds/webcontact/bad-peterstal-griesbach/pages/buerger-index.vue")
  },
  {
    name: "example",
    path: "/example",
    component: () => import("/builds/webcontact/bad-peterstal-griesbach/pages/example.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/builds/webcontact/bad-peterstal-griesbach/pages/index.vue")
  }
]